{
  "title": "Tools",
  "intro": "Draw an area to get imagery or analyse it. Nothing is kept unless you create a project.",
  "dock": {
    "label": "Canvas tools",
    "projects": "Projects",
    "areas": "Areas",
    "upload": "Upload area",
    "draw": "Draw area",
    "measure": "Measure",
    "basemap": "Basemap"
  },
  "hint": {
    "select": "Draw an area, or upload one, to start.",
    "selectHasAreas": "Click an area to choose what to do with it.",
    "polygon": "Click to place corners. Double-click to finish.",
    "measure": "Click to measure a distance. Double-click to finish."
  },
  "area": {
    "defaultName": "Area · {{when}}",
    "saving": "Saving the area…",
    "refused": "That area can't be used: {{reason}}",
    "failed": "The area couldn't be saved. Try again.",
    "hectares": "{{area}} ha"
  },
  "actions": {
    "title": "Select process:",
    "label": "Area actions",
    "image": "Image",
    "analyse": "Analyse",
    "simulate": "Prompt",
    "soon": "Coming soon",
    "delete": "Delete area",
    "createProject": "Create project"
  },
  "panel": {
    "close": "Close",
    "image": "Imagery",
    "analyse": "Analyse",
    "upload": "Upload an area",
    "areas": "Areas on this canvas"
  },
  "areas": {
    "none": "No areas yet. Draw or upload one.",
    "session": "Areas stay only while this page is open. Create a project to keep one.",
    "zoom": "Zoom to {{name}}"
  },
  "analyse": {
    "capture": "Imagery",
    "noCaptures": "Get an image first. Analysis runs on imagery acquired for this area.",
    "getImagery": "Get imagery",
    "analytics": "What to measure",
    "all": "All",
    "run": "Run analysis",
    "done": "Analysis finished. The land cover is on the map.",
    "downloads": "Downloads",
    "report": "Open the full report",
    "show": "Show on map",
    "hide": "Hide from map"
  },
  "create": {
    "keeps": "The area, its imagery and its analyses move into the project as they are."
  },
  "leave": {
    "title": "Leave the canvas?",
    "body": "Areas that aren't projects are cleared when you leave. Download what you need, or create a project to keep it.",
    "stay": "Stay",
    "go": "Leave"
  },
  "tips": {
    "dock": {
      "projects": "Go to your projects. Areas you have not made into a project stay here only until you leave.",
      "draw": "Draw an area on the map: click to place each corner, double-click to finish.",
      "areas": "List the areas on this canvas and zoom to one.",
      "measure": "Measure a distance on the map. Measurements are not saved.",
      "upload": "Add an area from a file: GeoJSON, KML or a zipped Shapefile, up to 5 MB."
    },
    "actions": {
      "image": "Find satellite imagery of this area by date, get a capture, compare two, or download one as GeoTIFF.",
      "analyse": "Map land cover, buildings, green and water, and roads from a capture of this area.",
      "simulate": "Describe a plan for this area in your own words and see options for it. Coming soon.",
      "delete": "Remove this area and everything made for it from the canvas.",
      "createProject": "Keep this area: it becomes a project, with its imagery and analyses inside."
    },
    "basemap": "Change the map underneath: satellite imagery, streets, or blank."
  },
  "image": {
    "provider": "Provider",
    "from": "Date start",
    "to": "Date end",
    "search": "Search",
    "ask": "Choose a provider and dates in the area's Image card.",
    "summary": "{{provider}} · {{from}} to {{to}}",
    "captured": "Captured",
    "preset": {
      "week": "This week",
      "month": "This month",
      "year": "This year",
      "2y": "Last 2 years",
      "5y": "Last 5 years",
      "all": "All",
      "custom": "Custom range"
    },
    "short": {
      "esri": "Esri",
      "google": "Google",
      "sentinel-2": "Sentinel-2",
      "landsat": "Landsat"
    }
  }
}
